// src/component/datatable2/hooks/useContainerWidth.ts

import { type RefObject, useEffect, useState } from 'react';

/** Measured pixel width of an element, kept up to date with a ResizeObserver (0 until measured). */
export function useContainerWidth(ref: RefObject<HTMLElement | null>): number {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const element = ref.current;

        if (!element) {
            return undefined;
        }

        const measure = () => setWidth(element.getBoundingClientRect().width);

        measure();

        if (typeof ResizeObserver === 'undefined') {
            return undefined;
        }

        const observer = new ResizeObserver(measure);

        observer.observe(element);

        return () => observer.disconnect();
    }, [ref]);

    return width;
}
